import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex); //vue的插件机制

//Vuex.Store 构造器选项
const store = new Vuex.Store({
  state: { //存放状态
    languageIndex: 0,
    languageCode:'en',
    languageData:[
      {
        name:'English',
        code:'en'
      },
      {
        name:'Chinese',
        code:'zh'
      }
    ],
    language:{}
  },
  mutations: {
    update(state, [key, value]) {
      state[key] = value
      if(key=="languageIndex"){
        let code = state.languageData[state.languageIndex].code
        state.languageCode = code
        // state.language = require('../static/language/language-'+state.languageCode+'.json');
      }
    }
  }
})

export default store



//////////////////
// WEBPACK FOOTER
// ./store/index.js
// module id = null
// module chunks = 